(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(13653);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; },
  "mockListings": function() { return /* binding */ mockListings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ui/button.tsx
var ui_button = __webpack_require__(67896);
// EXTERNAL MODULE: ./node_modules/date-fns/startOfToday.js
var startOfToday = __webpack_require__(93833);
// EXTERNAL MODULE: ./node_modules/date-fns/isBefore.js
var isBefore = __webpack_require__(12592);
// EXTERNAL MODULE: ./node_modules/date-fns/format.js + 7 modules
var format = __webpack_require__(28637);
// EXTERNAL MODULE: ./src/components/icons/icons8/icons8Search.tsx
var icons8Search = __webpack_require__(71646);
// EXTERNAL MODULE: ./src/components/ui/input.tsx + 12 modules
var input = __webpack_require__(46156);
// EXTERNAL MODULE: ./src/components/ui/calendar.tsx
var calendar = __webpack_require__(14685);
// EXTERNAL MODULE: ./src/components/ui/popover.tsx
var popover = __webpack_require__(93409);
// EXTERNAL MODULE: ./src/hooks/useScreenSize.tsx
var useScreenSize = __webpack_require__(71346);
// EXTERNAL MODULE: ./src/lib/functions.ts + 1 modules
var functions = __webpack_require__(96637);
// EXTERNAL MODULE: ./src/lib/utils.ts + 7 modules
var utils = __webpack_require__(15939);
;// CONCATENATED MODULE: ./src/components/custom/locality-input.tsx
"use client";






const LocalityInput = (param)=>{
    let { form , name ="address" , className ="" , placeholder ="Enter Location" , inputSize ="lg" , iconsClassName =""  } = param;
    const { width  } = (0,useScreenSize/* default */.Z)();
    const isSmall = width < 768;
    const inputRef = (0,react.useRef)(null);
    const dropdownRef = (0,react.useRef)(null);
    const timeoutRef = (0,react.useRef)(null);
    const [options, setOptions] = (0,react.useState)([]);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [isFocused, setIsFocused] = (0,react.useState)(false);
    // Handle outside click to close dropdown
    (0,react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
                setOptions([]);
                setIsFocused(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Clean up timeout on unmount
    (0,react.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const onValueChange = async (value)=>{
        form.setValue(name, value, {
            shouldValidate: true
        });
        if (value.trim() === "") {
            setOptions([]);
            return;
        }
        setIsLoading(true);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(async ()=>{
            try {
                const newOptions = await (0,functions/* generateLocalityOptions */.RB)(value, true);
                setOptions(newOptions);
            } catch (error) {
                console.error("Error fetching address options:", error);
            } finally{
                setIsLoading(false);
            }
        }, 300);
    };
    const handleSelect = (value)=>{
        var ref;
        form.setValue(name, value, {
            shouldValidate: true
        });
        setOptions([]);
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        setIsFocused(false);
    };
    // Get field state from form
    const fieldState = form.getFieldState(name, form.formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.II, {
                ref: inputRef,
                inputSize: isSmall ? "md" : inputSize,
                prefixIcon: input/* ICONS.LOCATION */.UZ.LOCATION,
                suffixIcon: isLoading ? input/* ICONS.LOCATION */.UZ.LOCATION : undefined,
                className: (0,utils.cn)("bg-white h-fit w-full", className),
                placeholder: placeholder,
                value: form.watch(name) || "",
                onChange: (e)=>onValueChange(e.target.value),
                onFocus: ()=>setIsFocused(true),
                fieldState: fieldState,
                iconsClassName: iconsClassName
            }),
            options.length > 0 && isFocused && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: dropdownRef,
                className: "bg-white max-h-[240px] overflow-auto absolute z-[999] w-full border border-gray-200 rounded-md mt-1 shadow-lg",
                children: options.map((option, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: ()=>handleSelect(option.value),
                        className: (0,utils.cn)("p-3 cursor-pointer hover:bg-gray-50 flex items-center gap-2", "text-sm border-b border-gray-100 last:border-b-0", {
                            "py-6.25 px-3.75 text-lg": inputSize === "lg",
                            "py-5 px-3.75": inputSize === "md"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,utils.cn)("text-gray-500 flex-shrink-0", {
                                    "w-7.5 h-7.5": inputSize === "lg",
                                    "w-5 h-5": inputSize === "md",
                                    "w-4.5 h-4.5": inputSize === "sm"
                                }, iconsClassName),
                                children: input/* icons */.ci[input/* ICONS.LOCATION */.UZ.LOCATION]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "flex-1",
                                children: option.text
                            })
                        ]
                    }, "".concat(option.value, "-").concat(index)))
            })
        ]
    });
};
// Import the icons object from the Input component

/* harmony default export */ var locality_input = (LocalityInput);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/redux/store.ts
var store = __webpack_require__(87442);
// EXTERNAL MODULE: ./src/redux/utils/index.ts
var redux_utils = __webpack_require__(34571);
// EXTERNAL MODULE: ./src/redux/listings/features.ts
var features = __webpack_require__(25642);
// EXTERNAL MODULE: ./src/components/ui/select.tsx
var ui_select = __webpack_require__(53666);
// EXTERNAL MODULE: ./node_modules/next/navigation.js
var navigation = __webpack_require__(39332);
;// CONCATENATED MODULE: ./src/components/page/home/hero/search.tsx
"use client";















const SearchListings = ()=>{
    const { width  } = (0,useScreenSize/* default */.Z)();
    const isSmall = width < 768;
    const today = (0,startOfToday/* startOfToday */.I)();
    const dispatch = (0,store/* useAppDispatch */.TL)();
    const router = (0,navigation.useRouter)();
    const searchParams = (0,navigation.useSearchParams)();
    // Set up form with react-hook-form
    const { setValue , watch , handleSubmit , control  } = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            location: "",
            startDate: undefined,
            endDate: undefined,
            type: ""
        }
    });
    // Watch the form values
    const startDate = watch("startDate");
    const endDate = watch("endDate");
    const CATEGORY_OPTIONS_FLAT = [
        {
            label: "ALL SPACES",
            value: "all",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.ALL */.fi.ALL
        },
        {
            label: "RESIDENCES",
            value: "residence",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.RESIDENCE */.fi.RESIDENCE
        },
        {
            label: "Beachfront Villas",
            value: "beachfront_villas",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.BEACHFRONT_VILLAS */.fi.BEACHFRONT_VILLAS
        },
        {
            label: "Apartments",
            value: "apartments",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.APARTMENTS */.fi.APARTMENTS
        },
        {
            label: "RETAIL (Pop-ups)",
            value: "retail",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.RETAIL */.fi.RETAIL
        },
        {
            label: "EXPERIENCES",
            value: "experiences-section",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.EXPERIENCES */.fi.EXPERIENCES
        },
        {
            label: "Sightseeing Tours",
            value: "sightseeing_tours",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.SIGHTSEEING_TOURS */.fi.SIGHTSEEING_TOURS
        },
        {
            label: "Private Boat Cruise",
            value: "private_boat_cruise",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.PRIVATE_BOAT_CRUISE */.fi.PRIVATE_BOAT_CRUISE
        },
        {
            label: "Other Experiences",
            value: "other_experiences",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.OTHER_EXPERIENCES */.fi.OTHER_EXPERIENCES
        },
        {
            label: "EVENT CENTERS",
            value: "event_center",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.EVENT_CENTER */.fi.EVENT_CENTER
        },
        {
            label: "ICONIC SPACES",
            value: "iconic",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.ICONIC */.fi.ICONIC
        }
    ];
    // Handle start date change
    const handleStartDateChange = (date)=>{
        setValue("startDate", date);
        // If end date exists and is before the new start date, reset end date
        if (date && endDate && (0,isBefore/* isBefore */.R)(endDate, date)) {
            setValue("endDate", undefined);
        }
    };
    // Handle end date change
    const handleEndDateChange = (date)=>{
        if (date && startDate && (0,isBefore/* isBefore */.R)(date, startDate)) {
            return;
        }
        setValue("endDate", date);
    };
    // Handle form submission
    const onSubmit = (data)=>{
        const params = new URLSearchParams(searchParams.toString());
        // Example: clear category if it exists
        if (params.has("category")) {
            params.delete("category");
        }
        // If after deleting there are no params left, go to root `/`
        const newUrl = params.toString() ? "?".concat(params.toString()) : "/";
        router.replace(newUrl);
        console.log("Search filters:", data);
        dispatch((0,features/* FilterHomePageListingRequest */.$Z)(data));
        dispatch((0,redux_utils/* SethomePageSearchClicked */.dX)(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "pt-7.5 md:pt-12.5 gap-1.25 flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex md:flex-row flex-col gap-1.25 lg:gap-0 min-w-[300px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(locality_input, {
                        form: {
                            setValue,
                            watch,
                            getFieldState: ()=>({
                                    error: undefined
                                })
                        },
                        name: "location"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverTrigger */.xo, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-full md:w-[250px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.II, {
                                        inputSize: isSmall ? "md" : "lg",
                                        prefixIcon: input/* ICONS.CALENDAR */.UZ.CALENDAR,
                                        className: "bg-black w-full bg-opacity-10 backdrop-blur-lg text-white h-fit placeholder:text-[rgba(255,255,255,0.6)] border-opacity-20 cursor-pointer",
                                        placeholder: "Start Date",
                                        iconsClassName: "fill-white",
                                        value: startDate ? (0,format/* format */.WU)(startDate, "PPP") : "",
                                        readOnly: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverContent */.yk, {
                                className: "w-auto p-0",
                                align: "start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar/* Calendar */.f, {
                                    mode: "single",
                                    className: "w-[250px]",
                                    selected: startDate,
                                    onSelect: handleStartDateChange,
                                    disabled: (date)=>(0,isBefore/* isBefore */.R)(date, today),
                                    initialFocus: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverTrigger */.xo, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-full md:w-[250px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.II, {
                                        inputSize: isSmall ? "md" : "lg",
                                        prefixIcon: input/* ICONS.CALENDAR */.UZ.CALENDAR,
                                        className: "bg-white h-fit w-full cursor-pointer",
                                        placeholder: "End Date",
                                        value: endDate ? (0,format/* format */.WU)(endDate, "PPP") : "",
                                        readOnly: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverContent */.yk, {
                                className: "w-auto p-0",
                                align: "start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar/* Calendar */.f, {
                                    mode: "single",
                                    className: "w-[250px]",
                                    selected: endDate,
                                    onSelect: handleEndDateChange,
                                    disabled: (date)=>(0,isBefore/* isBefore */.R)(date, today) || (startDate ? (0,isBefore/* isBefore */.R)(date, startDate) : false),
                                    initialFocus: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        name: "type",
                        control: control,
                        render: (param)=>/*#__PURE__*/ {
                            let { field  } = param;
                            return (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                                onValueChange: field.onChange,
                                value: field.value,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                        className: " md:w-[200px] bg-black h-fitbg-black w-full bg-opacity-10 backdrop-blur-lg text-white h-fit placeholder:text-[rgba(255,255,255,0.6)] border-opacity-20 cursor-pointer min-h-[80px] text-lg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                            placeholder: "Select type"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                        children: CATEGORY_OPTIONS_FLAT.map((e)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                                value: e.enumValue,
                                                children: e.label
                                            }, e.enumValue))
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                type: "submit",
                className: "w-20 h-20 md:w-25 md:h-25 primary-gradient mt-5 rounded-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons8Search/* default */.Z, {
                    className: "fill-white h-7.5"
                })
            })
        ]
    });
};
/* harmony default export */ var search = (SearchListings);

;// CONCATENATED MODULE: ./src/components/page/home/hero/main.tsx


const MainHeroContent = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center pt-7.5 sm:pt-[50px] w-full lg:px-0 px-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-white text-xs md:text-sm text-opacity-70 px-5 py-2.5 bg-[#000] bg-opacity-10 backdrop-blur-lg rounded-full border-[rgba(255,255,255,0.1)] border",
                children: "✦ We are live in Nigeria today!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "text-white mt-2.5 text-center text-4xl md:text-6xl lg:text-7xl tracking-tight",
                children: [
                    "Book with ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-display",
                        children: "ease"
                    }),
                    " today  ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-display",
                        children: "&"
                    }),
                    " make that",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-display",
                        children: "Dream"
                    }),
                    " a reality."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2.5 md:mt-3.75 text-white text-center text-base lg:text-xl text-opacity-90",
                children: "Listings range from Residences, Retail (Pop ups), Event centers and Experiences."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {})
        ]
    });
};
/* harmony default export */ var main = (MainHeroContent);

// EXTERNAL MODULE: ./src/components/page/home/hero/nav.tsx
var nav = __webpack_require__(64043);
;// CONCATENATED MODULE: ./src/components/icons/Vuesax/vuesaxBoldMessages.tsx

const VuesaxBoldMessages = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 30,
        height: 31,
        viewBox: "0 0 30 31",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19.4875 16.2159V21.3034C19.4875 21.7534 19.4375 22.1784 19.325 22.5659C18.8625 24.4034 17.3375 25.5534 15.2375 25.5534H11.8375L8.0625 28.0659C7.5 28.4534 6.75 28.0409 6.75 27.3659V25.5534C5.475 25.5534 4.4125 25.1284 3.675 24.3909C2.925 23.6409 2.5 22.5784 2.5 21.3034V16.2159C2.5 13.8409 3.975 12.2034 6.25 11.9909C6.4125 11.9784 6.575 11.9659 6.75 11.9659H15.2375C17.7875 11.9659 19.4875 13.6659 19.4875 16.2159Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M22.1875 20.2159C23.775 20.2159 25.1125 19.6909 26.0375 18.7534C26.975 17.8284 27.5 16.4909 27.5 14.9034V8.52844C27.5 5.59094 25.125 3.21594 22.1875 3.21594H11.5625C8.625 3.21594 6.25 5.59094 6.25 8.52844V9.46594C6.25 9.81594 6.525 10.0909 6.875 10.0909H15.2375C18.625 10.0909 21.3625 12.8284 21.3625 16.2159V19.5909C21.3625 19.9409 21.6375 20.2159 21.9875 20.2159H22.1875Z"
                })
            ]
        })
    });
/* harmony default export */ var vuesaxBoldMessages = (VuesaxBoldMessages);

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/x.js
var x = __webpack_require__(41352);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/mail.js
var mail = __webpack_require__(56953);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/send.js
var send = __webpack_require__(42841);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./src/redux/users/features.ts
var users_features = __webpack_require__(60233);
// EXTERNAL MODULE: ./src/hooks/useToastListner.tsx
var useToastListner = __webpack_require__(30533);
;// CONCATENATED MODULE: ./src/components/page/home/hero/index.tsx












// ✅ Validation Schema
const ContactSchema = yup_index_esm/* object */.Ry().shape({
    email: yup_index_esm/* string */.Z_().email("Invalid email").required("Email is required"),
    message: yup_index_esm/* string */.Z_().min(5, "Message must be at least 5 characters").required("Message is required")
});
const Hero = (param)=>{
    let { howItWorksRef  } = param;
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const dispatch = (0,store/* useAppDispatch */.TL)();
    (0,useToastListner/* useToastListener */.f)();
    const SendMessage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "fixed inset-0 z-50 flex items-center justify-center p-4 animate-in fade-in duration-200",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 bg-black bg-opacity-70 backdrop-blur-sm",
                    onClick: ()=>setIsModalOpen(false)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative bg-white bg-opacity-10 backdrop-blur-xl border border-white border-opacity-20 rounded-2xl shadow-2xl w-full max-w-md p-8 animate-in zoom-in duration-300",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>setIsModalOpen(false),
                            className: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x/* default */.Z, {
                                size: 24
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4 mx-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mail/* default */.Z, {
                                        className: "text-white",
                                        size: 32
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-bold text-white text-center mb-2",
                                    children: "Get In Touch"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-white text-opacity-80 text-center",
                                    children: "Send us a message and we'll get back to you soon"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            initialValues: {
                                email: "",
                                message: ""
                            },
                            validationSchema: ContactSchema,
                            onSubmit: async (values, param)=>{
                                let { setSubmitting , resetForm  } = param;
                                // simulate API request
                                await dispatch((0,users_features/* sendHomeEmail */.nY)(values.email, values.message));
                                setSubmitting(false);
                                resetForm();
                                setIsModalOpen(false);
                            },
                            children: (param)=>/*#__PURE__*/ {
                                let { errors , touched , isSubmitting  } = param;
                                return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "email",
                                                    className: "block text-white text-sm font-medium mb-2",
                                                    children: "Email Address"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    type: "email",
                                                    id: "email",
                                                    name: "email",
                                                    placeholder: "your@email.com",
                                                    className: "w-full px-4 py-3 bg-white bg-opacity-10 border border-white border-opacity-30 rounded-lg text-white placeholder-white placeholder-opacity-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 transition-all"
                                                }),
                                                errors.email && touched.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-red-400 text-sm mt-1",
                                                    children: errors.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "message",
                                                    className: "block text-white text-sm font-medium mb-2",
                                                    children: "Message"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    as: "textarea",
                                                    id: "message",
                                                    name: "message",
                                                    placeholder: "Tell us what's on your mind...",
                                                    rows: 5,
                                                    className: "w-full px-4 py-3 bg-white bg-opacity-10 border border-white border-opacity-30 rounded-lg text-white placeholder-white placeholder-opacity-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 transition-all resize-none"
                                                }),
                                                errors.message && touched.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-red-400 text-sm mt-1",
                                                    children: errors.message
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            disabled: isSubmitting,
                                            className: "w-full py-3 px-6 bg-white text-black font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                            children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin"
                                                    }),
                                                    "Sending..."
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(send/* default */.Z, {
                                                        size: 18
                                                    }),
                                                    "Send Message"
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 pt-6 border-t border-white border-opacity-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-white text-opacity-70 text-sm text-center",
                                children: [
                                    "Or email us directly at",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:shortlet@myblankspace.com",
                                        className: "text-white font-semibold hover:underline",
                                        children: "shortlet@myblankspace.com"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "min-h-[800px] h-screen relative w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute w-full h-full left-0 top-0 z-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-black bg-opacity-60 absolute w-full h-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full h-full object-cover",
                        src: "https://storage.googleapis.com/myblankspace-prod/assets/bg.png",
                        alt: "Hero background"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-10 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(nav/* default */.ZP, {
                        howItWorksRef: howItWorksRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                className: "h-[60px] w-[60px] md:h-[70px] md:w-[70px] bg-black bg-opacity-10 backdrop-blur-lg border border-white border-opacity-10 mt-5 rounded-full absolute right-5 bottom-10 md:right-12.5 md:bottom-25",
                onClick: ()=>setIsModalOpen(true),
                "aria-label": "Open contact modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vuesaxBoldMessages, {
                    className: "fill-white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full absolute bottom-0 left-0 flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-12.5 h-6.25 bg-white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-12.5 h-6.25 bg-white"
                    })
                ]
            }),
            isModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SendMessage, {})
        ]
    });
};
/* harmony default export */ var hero = (Hero);

// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/page/home/featured/featured.tsx
"use client";





const FeaturedListing = (param)=>{
    let { listing , placeCutoutAtTop =false  } = param;
    const { data: session  } = (0,next_auth_react.useSession)();
    const router = (0,navigation.useRouter)();
    const [isHovered, setIsHovered] = (0,react.useState)(false);
    const handleClick = ()=>{
        router.push("/listings/".concat(listing.id));
        if ((session === null || session === void 0 ? void 0 : session.user.role) === "booker") {
        // Additional logic for bookers can go here
        }
    };
    const enabledDiscounts = (listing.discounts || []).filter((d)=>d.enable_discount && d.discount > 0);
    const maxDiscount = enabledDiscounts.length > 0 ? Math.max(...enabledDiscounts.map((d)=>d.discount)) : 0;
    const originalPrice = listing.price;
    const discountedPrice = maxDiscount ? originalPrice * (1 - maxDiscount / 100) : originalPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "group cursor-pointer",
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: "aspect-square w-full relative overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: listing.img || "/placeholder.svg",
                        alt: listing.description,
                        className: (0,utils.cn)("object-cover w-full h-full transition-all duration-300", {
                            "filter brightness-75": isHovered
                        })
                    }),
                    enabledDiscounts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-3 left-3 bg-green-500 text-white px-2 py-1 rounded-md text-xs font-semibold z-10",
                        children: [
                            enabledDiscounts.length,
                            " Discount",
                            enabledDiscounts.length > 1 ? "s" : "",
                            " Available"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,utils.cn)("flex items-center justify-between absolute left-0 w-full transition-all duration-300", {
                            "top-0": placeCutoutAtTop,
                            "bottom-0": !placeCutoutAtTop
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-2.5 lg:w-10 aspect-square bg-white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-2.5 lg:w-10 aspect-square bg-white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,utils.cn)("absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-lg md:text-xl lg:text-2xl font-serif font-bold tracking-wide transition-all duration-300", {
                            "opacity-100": isHovered,
                            "opacity-0": !isHovered
                        }),
                        style: {
                            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)"
                        },
                        children: "Explore Listing"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-1.5 text-1xs md:text-sm lg:text-base",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-dark-gray font-semibold text-lg ellipsis-1",
                            children: listing.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-gray-secondary text-sm line-clamp-2 md:line-clamp-3",
                            children: listing.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between mt-2.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-gray-secondary text-xs md:text-sm",
                                    children: [
                                        listing.size,
                                        " ",
                                        listing.size_unit
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col items-end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-gray-600 font-semibold text-xs",
                                        children: [
                                            "NGN ",
                                            originalPrice.toLocaleString(),
                                            " / ",
                                            listing.interval
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }, listing.id);
};
/* harmony default export */ var featured = (FeaturedListing);

;// CONCATENATED MODULE: ./src/components/page/home/featured/index.tsx
"use client";









/**
|--------------------------------------------------
| Featured Listings Component
|--------------------------------------------------
*/ const FeaturedListings = ()=>{
    const dispatch = (0,store/* useAppDispatch */.TL)();
    const router = (0,navigation.useRouter)();
    const { data: session  } = (0,next_auth_react.useSession)();
    const { publicListings , homePageListings  } = (0,store/* useAppSelector */.CG)((state)=>state.listing);
    const { homePageSearchClicked  } = (0,store/* useAppSelector */.CG)((state)=>state.utils);
    const searchParams = (0,navigation.useSearchParams)();
    const currentCategory = searchParams.get("category") || "all";
    const [listings, setListings] = (0,react.useState)({});
    const [openDropdown, setOpenDropdown] = (0,react.useState)(null);
    /**
  |--------------------------------------------------
  | Category Options (Main + Subcategories)
  |--------------------------------------------------
  */ const CATEGORY_OPTIONS = [
        {
            label: "ALL SPACES",
            value: "all",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.ALL */.fi.ALL
        },
        {
            label: "RESIDENCES",
            value: "residence",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.RESIDENCE */.fi.RESIDENCE,
            subcategories: [
                {
                    label: "Beachfront Villas",
                    value: "beachfront_villas",
                    enumValue: features/* PUBLIC_LISTING_CATEGORIES.BEACHFRONT_VILLAS */.fi.BEACHFRONT_VILLAS
                },
                {
                    label: "Apartments",
                    value: "apartments",
                    enumValue: features/* PUBLIC_LISTING_CATEGORIES.APARTMENTS */.fi.APARTMENTS
                }
            ]
        },
        {
            label: "RETAIL (Pop-ups)",
            value: "retail",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.RETAIL */.fi.RETAIL
        },
        {
            label: "EXPERIENCES",
            value: "experiences-section",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.EXPERIENCES */.fi.EXPERIENCES,
            subcategories: [
                {
                    label: "Sightseeing Tours",
                    value: "sightseeing_tours",
                    enumValue: features/* PUBLIC_LISTING_CATEGORIES.SIGHTSEEING_TOURS */.fi.SIGHTSEEING_TOURS
                },
                {
                    label: "Private Boat Cruise",
                    value: "private_boat_cruise",
                    enumValue: features/* PUBLIC_LISTING_CATEGORIES.PRIVATE_BOAT_CRUISE */.fi.PRIVATE_BOAT_CRUISE
                },
                {
                    label: "Other Experiences",
                    value: "other_experiences",
                    enumValue: features/* PUBLIC_LISTING_CATEGORIES.OTHER_EXPERIENCES */.fi.OTHER_EXPERIENCES
                }
            ]
        },
        {
            label: "EVENT CENTERS",
            value: "event_center",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.EVENT_CENTER */.fi.EVENT_CENTER
        },
        {
            label: "ICONIC SPACES",
            value: "iconic",
            enumValue: features/* PUBLIC_LISTING_CATEGORIES.ICONIC */.fi.ICONIC
        }
    ];
    /**
  |--------------------------------------------------
  | Helpers
  |--------------------------------------------------
  */ const getCurrentCategoryEnum = ()=>{
        // Check main categories
        const main = CATEGORY_OPTIONS.find((opt)=>opt.value === currentCategory);
        if (main) return main.enumValue;
        // Check subcategories
        for (const option of CATEGORY_OPTIONS){
            if (option.subcategories) {
                const sub = option.subcategories.find((s)=>s.value === currentCategory);
                if (sub) return sub.enumValue;
            }
        }
        return features/* PUBLIC_LISTING_CATEGORIES.ALL */.fi.ALL;
    };
    const toggleDropdown = (value)=>{
        setOpenDropdown(openDropdown === value ? null : value);
    };
    const handleViewMoreClick = ()=>{
        router.push("/listings");
    };
    /**
  |--------------------------------------------------
  | Effects
  |--------------------------------------------------
  */ (0,react.useEffect)(()=>{
        if (publicListings === null || publicListings === void 0 ? void 0 : publicListings.data.categories) {
            setListings(publicListings.data.categories);
        }
    }, [
        publicListings
    ]);
    // Initial fetch (all)
    (0,react.useEffect)(()=>{
        const params = {
            location: "Nigeria",
            category: features/* PUBLIC_LISTING_CATEGORIES.ALL */.fi.ALL,
            pagination: {
                page: 1,
                per_page: 6
            },
            filters: {
                verification_status: features/* LISTING_VERIFICATION_STATUS.APPROVED */.$X.APPROVED
            }
        };
        dispatch((0,features/* getPublicListingsRequest */.Kf)(params));
    }, [
        dispatch
    ]);
    // Refetch on category change (including "all")
    (0,react.useEffect)(()=>{
        if (homePageSearchClicked) return;
        const params = {
            location: "Nigeria",
            category: getCurrentCategoryEnum(),
            pagination: {
                page: 1,
                per_page: 6
            },
            filters: {
                verification_status: features/* LISTING_VERIFICATION_STATUS.APPROVED */.$X.APPROVED
            }
        };
        dispatch((0,features/* getPublicListingsRequest */.Kf)(params));
    }, [
        currentCategory,
        homePageSearchClicked,
        dispatch
    ]);
    /**
  |--------------------------------------------------
  | Filter listings to render
  |--------------------------------------------------
  */ const listingsToRender = (()=>{
        if (homePageSearchClicked) {
            const searchListings = (homePageListings === null || homePageListings === void 0 ? void 0 : homePageListings.listings) || [];
            if (currentCategory === "all") return searchListings;
            const currentEnum = getCurrentCategoryEnum();
            return searchListings.filter((listing)=>listing.category === currentEnum);
        }
        if (currentCategory === "all") {
            return Object.values(listings).flat();
        }
        const currentEnum1 = getCurrentCategoryEnum();
        return listings[currentEnum1] || [];
    })();
    /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "w-full pt-10 pb-16 border-b border-gray-muted flex flex-col text-center items-center text-dark-primary px-4 sm:px-6 lg:px-12 xl:px-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center tracking-tight mb-6",
                children: [
                    "Featured ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-display",
                        children: "Spaces"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex flex-col items-center mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    className: "flex items-center py-2.5 border-b bg-gray-50/50 rounded-lg flex-wrap border-gray-100",
                    children: CATEGORY_OPTIONS.map((param)=>{
                        let { label , value , subcategories  } = param;
                        const isActive = value === currentCategory || subcategories && subcategories.some((s)=>s.value === currentCategory);
                        if (subcategories) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                        href: "?category=".concat(value),
                                        scroll: false,
                                        onClick: ()=>toggleDropdown(value),
                                        className: "px-4 py-2 mx-1 text-xs font-medium whitespace-nowrap rounded-md transition-all duration-200 flex items-center gap-2 ".concat(isActive ? "bg-white text-[#279A86] font-semibold" : "text-gray-600 hover:text-[#279A86] hover:bg-white"),
                                        children: [
                                            label,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: "w-3 h-3 transition-transform duration-200 ".concat(openDropdown === value ? "rotate-180" : ""),
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M19 9l-7 7-7-7"
                                                })
                                            })
                                        ]
                                    }),
                                    openDropdown === value && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute left-0 top-full mt-2 bg-white border border-gray-200 rounded-xl shadow-xl z-50 min-w-[180px] overflow-hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "py-2",
                                            children: subcategories.map((sub, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "?category=".concat(sub.value),
                                                    scroll: false,
                                                    onClick: ()=>setOpenDropdown(null),
                                                    className: "block px-4 py-3 text-sm transition-all duration-150 ".concat(sub.value === currentCategory ? "bg-blue-50 text-[#279A86] font-medium border-r-2 border-blue-500" : "text-gray-700 hover:text-[#279A86] hover:bg-gray-50", " ").concat(i !== subcategories.length - 1 ? "border-b border-gray-100" : ""),
                                                    children: sub.label
                                                }, sub.value))
                                        })
                                    })
                                ]
                            }, value);
                        }
                        // Normal category
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "?category=".concat(value),
                            scroll: false,
                            className: "flex-shrink-0 px-4 py-2 mx-1 text-xs font-medium whitespace-nowrap rounded-md transition-all duration-200 ".concat(isActive ? "bg-white text-[#279A86] font-semibold" : "text-gray-600 hover:bg-white hover:shadow-sm"),
                            children: label
                        }, value);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-4 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-10 lg:gap-12 min-h-[400px]",
                children: listingsToRender.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center col-span-full text-gray-500 flex items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "No listings found for this category"
                    })
                }) : listingsToRender.map((listing, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(featured, {
                        listing: {
                            img: listing.images[0],
                            name: listing.name,
                            description: listing.description,
                            size: listing === null || listing === void 0 ? void 0 : listing.size,
                            size_unit: listing === null || listing === void 0 ? void 0 : listing.size_unit,
                            id: listing.id,
                            price: listing === null || listing === void 0 ? void 0 : listing.base_price,
                            interval: listing === null || listing === void 0 ? void 0 : listing.base_price_interval,
                            discounts: Array.isArray(listing.discounts) ? listing.discounts.map((e)=>({
                                    enable_discount: e.enable_discount,
                                    discount: e.discount
                                })) : []
                        }
                    }, listing.id || index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                onClick: handleViewMoreClick,
                className: "px-5 py-2 text-sm sm:text-base border border-gray-muted rounded-full mt-6",
                variant: "ghost",
                children: "VIEW MORE ↗"
            })
        ]
    });
};
/* harmony default export */ var home_featured = (FeaturedListings);

// EXTERNAL MODULE: ./src/components/page/home/faqs/index.tsx + 1 modules
var faqs = __webpack_require__(52998);
;// CONCATENATED MODULE: ./src/components/page/home/learn.tsx


const HowItWorks = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const videoId = "gjr20aijiU8";
    const videoUrl = "https://www.youtube.com/watch?v=".concat(videoId);
    const embedUrl = "https://www.youtube.com/embed/".concat(videoId, "?autoplay=1&mute=0");
    const [isHovered, setIsHovered] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: ref,
        className: "w-full pt-15 md:pt-[100px] pb-[50px] flex flex-col items-center text-dark-primary px-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "text-2xl sm:text-3xl md:text-4xl tracking-tight",
                children: [
                    "How it ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-display",
                        children: "Works"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full lg:w-[1060px] aspect-video mt-5 md:mt-7.5 rounded-xl md:rounded-2xl lg:rounded-[40px] overflow-hidden cursor-pointer relative",
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: videoUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: !isHovered ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full h-full object-cover absolute inset-0",
                        src: "https://storage.googleapis.com/myblankspace-prod/assets/vid.png",
                        alt: "Video preview"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        className: "w-full h-full absolute inset-0",
                        src: embedUrl,
                        title: "YouTube video player",
                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true
                    })
                })
            })
        ]
    });
});
HowItWorks.displayName = "HowItWorks";
/* harmony default export */ var learn = (HowItWorks);

// EXTERNAL MODULE: ./src/components/page/home/why.tsx
var why = __webpack_require__(65160);
// EXTERNAL MODULE: ./src/components/page/home/footer/index.tsx + 3 modules
var footer = __webpack_require__(58930);
;// CONCATENATED MODULE: ./pages/index.tsx









// Mock listings data
const mockListings = [
    {
        img: "https://storage.googleapis.com/myblankspace-prod/mock/listing%201.png",
        price: 4000,
        interval: "month",
        size: 500,
        size_unit: "sqm",
        description: "Large open space for meets. Banana island - Lagos, Nigeria"
    },
    {
        img: "https://storage.googleapis.com/myblankspace-prod/mock/listing%202.png",
        price: 40000,
        interval: "month",
        size: 400,
        size_unit: "sqm",
        description: "Beautiful minimal showroom Ekong road - Calabar"
    },
    {
        img: "https://storage.googleapis.com/myblankspace-prod/mock/listing%203.png",
        price: 100000,
        interval: "month",
        size: 200,
        size_unit: "sqm",
        description: "Casual seminar space Ikeja - Lagos, Nigeria"
    },
    {
        img: "https://storage.googleapis.com/myblankspace-prod/mock/listing%204.png",
        price: 100000,
        interval: "month",
        size: 200,
        size_unit: "sqm",
        description: "Large open space for meets. Banana island - Lagos, Nigeria"
    },
    {
        img: "https://storage.googleapis.com/myblankspace-prod/mock/listing%205.png",
        price: 100000,
        interval: "month",
        size: 200,
        size_unit: "sqm",
        description: "Casual seminar space Ikeja - Lagos, Nigeria"
    },
    {
        img: "https://storage.googleapis.com/myblankspace-prod/mock/listing%206.png",
        price: 100000,
        interval: "month",
        size: 200,
        size_unit: "sqm",
        description: "Beautiful minimal showroom Ekong road - Calabar"
    }
];
const HomePage = ()=>{
    const { homePageSearchClicked  } = (0,store/* useAppSelector */.CG)((state)=>state.utils);
    const howItWorksRef = (0,react.useRef)(null);
    // Define animation variants
    const sectionVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0
        },
        exit: {
            opacity: 0,
            y: -20
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "flex flex-col items-center overflow-hidden text-lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {
                howItWorksRef: howItWorksRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_featured, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(learn, {
                ref: howItWorksRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(faqs/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(why/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.ZP, {})
        ]
    });
};
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 52998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ faqs; }
});

// UNUSED EXPORTS: mockQuestions

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/icons/icons8/icons8PlusMath.tsx
var icons8PlusMath = __webpack_require__(36878);
// EXTERNAL MODULE: ./src/lib/utils.ts + 7 modules
var utils = __webpack_require__(15939);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/page/home/faqs/accordion.tsx




const FaqAccordion = (param)=>{
    let { content , title  } = param;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: ()=>setOpen(!open),
                className: "w-full cursor-pointer select-none flex justify-between hover:bg-gray-muted hover:bg-opacity-10 items-center py-[25px] border-b border-gray-muted",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: " md:text-lg text-1sm text-dark-primary",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,utils.cn)("duration-500", {
                            "rotate-[225deg]": open,
                            "rotate-0": !open
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons8PlusMath/* default */.Z, {
                            className: (0,utils.cn)("fill-dark-gray hover:fill-primary-500")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,utils.cn)("overflow-hidden duration-300", {
                    "max-h-0": !open,
                    "max-h-[200px] border-b border-gray-muted": open
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "py-7.5 lg:text-base text-sm lg:w-[50%] text-gray-primary",
                    children: content
                })
            })
        ]
    });
};
/* harmony default export */ var accordion = (FaqAccordion);

;// CONCATENATED MODULE: ./src/components/page/home/faqs/index.tsx


const FAQs = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "w-full pt-[50px] pb-20 lg:pb-[100px] flex flex-col items-center text-dark-primary ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-2xl sm:text-3xl md:text-4xl tracking-tight",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-display",
                    children: "FAQs"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[1024px] w-full px-5 md:px-25 md:mt-0 mt-3.75",
                children: mockQuestions.map((q, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(accordion, {
                        title: q.title,
                        content: q.content
                    }, i))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-25 w-full h-fit relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full absolute bottom-0 left-0 flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-5 md:w-12.5 aspect-square bg-white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-5 md:w-12.5 aspect-square bg-white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full absolute top-0 left-0 flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-5 md:w-12.5 aspect-square bg-white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-5 md:w-12.5 aspect-square bg-white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://storage.googleapis.com/myblankspace-prod/assets/shop-view.png",
                        className: "w-full h-full object-cover"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var faqs = (FAQs);
const mockQuestions = [
    {
        title: "What is Myblankspace?",
        content: "Is an online platform that allows users to book various types of spaces, including Retail, Conference Rooms, Experiences and Events Venues and more."
    },
    {
        title: "Is there a fee to use SpaceBooker?",
        content: "There is a 3% Service fee applied to booking a space on the platform, this helps cover the costs associated with running and maintaining the booking platform, including technology, customer support and processing payments."
    },
    {
        title: "What payment methods do you accept?",
        content: "We accept payments from customers using different payment channels such as: cards, mobile money accounts, Paypal, directly from their bank account."
    },
    {
        title: "Can I cancel or modify my booking?",
        content: "Cancellation policy is determined by the Host. Each Listing specifies the terms for cancellation and any applicable refund. If you cancel a booking, the amount refunded to you is determined by the cancellation policy of the Listing."
    },
    {
        title: "Will I receive a refund if I cancel my booking?",
        content: "MyBlankSpace will initiate any refund within a commercially reasonable time after the cancellation, subject to these Terms and any specific Listing cancellation policy, which may range from flexible to strict.  MyBlankSpace will refund your booking fee should the Host fail to fulfil the booking as agreed."
    }
];


/***/ }),

/***/ 65160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const WhyUs = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "pt-0 pb-[100px] lg:pb-[200px] px-5 lg:px-25 w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "grid grid-cols-1 lg:grid-cols-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            className: "text-xs md:text-sm p-2.5 rounded-full border border-gray-muted w-fit text-dark-primary font-medium",
                            children: "WHY US"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mt-6.25 text-3xl lg:text-5xl text-dark-gray w-[80%] md:w-[60%] tracking-tight",
                            children: [
                                "What sets us apart and makes us the",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-display text-primary-500",
                                    children: " Best Choice"
                                }),
                                " ",
                                "for your needs?"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-2 gap-x-5 md:gap-x-12.5 xl:gap-x-25 gap-y-5 md:gap-y-12.5 lg:mt-0 mt-12.5",
                    children: whyUsInfo.map((i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "pr-2.5 sm:pr-7.5 md:pr-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-12.5 sm:w-15 md:w-16.25",
                                    children: i.illustration
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    className: "font-medium sm:text-lg md:text-xl text-dark-primary tracking-tight my-5",
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: " text-dark-gray md:text-base text-1xs sm:text-1sm",
                                    children: [
                                        " ",
                                        i.description,
                                        " "
                                    ]
                                })
                            ]
                        }))
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WhyUs);
const whyUsInfo = [
    {
        illustration: //prettier-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "w-full",
            viewBox: "0 0 68 69",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    stroke: "#EBEBEB",
                    "stroke-width": "1.4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M34 18.97C31.1875 18.97 29.3031 20.0735 27.606 20.9963C25.9088 21.9192 24.352 22.72 21.5 22.72H20.25V23.97C20.25 33.6173 23.5063 39.8936 26.8076 43.6917C30.109 47.4897 33.5337 48.8796 33.5337 48.8796L33.9976 49.0652L34.459 48.8821C34.459 48.8821 37.8896 47.5089 41.1924 43.7185C44.4951 39.9281 47.75 33.6513 47.75 23.97V22.72H46.5C43.6635 22.72 42.1053 21.9196 40.4038 20.9963C38.7023 20.073 36.8125 18.97 34 18.97ZM34 21.47C36.1875 21.47 37.4586 22.2419 39.2124 23.1936C40.6901 23.9954 42.6389 24.7523 45.1646 25.0125C44.9286 33.4746 42.1311 38.8351 39.3076 42.0754C36.7427 45.0191 34.5997 46.0387 34.0024 46.304C33.4037 46.0346 31.2578 45.0025 28.6924 42.051C25.8681 38.8018 23.0746 33.4406 22.8379 25.0125C25.372 24.7524 27.3244 23.9934 28.7998 23.1912C30.5508 22.239 31.8125 21.47 34 21.47ZM34 26.5164L32.2935 30.4128L28.0063 30.8694L31.0898 33.6135L30.2476 37.8591L34 35.6936L37.7524 37.8591L36.9102 33.6135L39.9937 30.8694L35.7065 30.4128L34 26.5164Z",
                    fill: "#2AA58F"
                })
            ]
        }),
        title: "Secure Payments",
        description: "Our secure payment system ensures that your financial information is protected at all times."
    },
    {
        illustration: //prettier-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "w-full",
            viewBox: "0 0 68 69",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    stroke: "#EBEBEB",
                    "stroke-width": "1.4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M34 20.188L19.8203 25.3442L19 25.6567V45.2661H26.5V42.7661H21.5V27.3755L34 22.8442L46.5 27.3755V42.7661H41.5V45.2661H49V25.6567L48.1797 25.3442L34 20.188ZM27.75 30.2661V48.5474L34 45.4224L40.25 48.5474V30.2661H27.75ZM30.25 32.7661H37.75V44.4849L34 42.6099L30.25 44.4849V32.7661Z",
                    fill: "#2AA58F"
                })
            ]
        }),
        title: "Seemless Booking",
        description: "Our user-friendly interface allows you to search, compare, and book spaces in just a few clicks"
    },
    {
        illustration: //prettier-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "w-full",
            viewBox: "0 0 68 69",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    stroke: "#EBEBEB",
                    "stroke-width": "1.4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M34.0024 17.2778L33.1333 18.1177L29.8618 21.2793L24.1611 20.4736L23.1675 26.145L18.082 28.8428L20.6089 34.0161L18.082 39.1895L23.1675 41.8872L24.1611 47.5586L29.8618 46.7529L34.0024 50.7544L38.1382 46.7529L43.8389 47.5586L44.835 41.8872L49.9204 39.1895L47.3936 34.0161L49.9204 28.8428L44.835 26.145L43.8389 20.4736L38.1382 21.2793L34.0024 17.2778ZM34 20.7544L37.2788 23.9258L41.7954 23.2886L42.584 27.7808L46.6123 29.9194L44.6104 34.0161L46.6123 38.1128L42.584 40.2515L41.7954 44.7437L37.2788 44.1064L34 47.2778L30.7236 44.1064L26.207 44.7437L25.4185 40.2515L21.3901 38.1128L23.3921 34.0161L21.3901 29.9194L25.4185 27.7808L26.207 23.2886L30.7236 23.9258L34 20.7544ZM39.3369 28.9697L31.5 36.8066L27.3838 32.6904L25.6162 34.458L31.5 40.3418L41.1045 30.7373L39.3369 28.9697Z",
                    fill: "#2AA58F"
                })
            ]
        }),
        title: "Verified Listings",
        description: "Each space is thoroughly checked and approved, so you can trust that what you see is what you get."
    },
    {
        illustration: //prettier-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "w-full",
            viewBox: "0 0 68 69",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.7",
                    y: "0.716113",
                    width: "66.6",
                    height: "66.6",
                    rx: "33.3",
                    stroke: "#EBEBEB",
                    "stroke-width": "1.4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M34 17.1411L32.9062 19.1333L28.2578 27.6099L18.7656 29.4067L16.5391 29.8364L18.1016 31.5161L24.7031 38.5474L23.4922 48.1177L23.2188 50.3833L25.25 49.4067L34 45.3442L42.75 49.4067L44.7812 50.3833L44.5078 48.1177L43.2969 38.5474L49.8984 31.5161L51.4609 29.8364L49.2344 29.4067L39.7422 27.6099L35.0938 19.1333L34 17.1411ZM34 22.3364L37.8281 29.3286L38.1406 29.8364L38.6875 29.9536L46.5391 31.438L41.0703 37.2583L40.6797 37.688L40.7578 38.2739L41.7734 46.2036L34.5469 42.8052L34 42.5317L33.4531 42.8052L26.2266 46.2036L27.2422 38.2739L27.3203 37.688L26.9297 37.2583L21.4609 31.438L29.3125 29.9536L29.8594 29.8364L30.1719 29.3286L34 22.3364ZM32.75 30.2661V34.0161H29V36.5161H32.75V40.2661H35.25V36.5161H39V34.0161H35.25V30.2661H32.75Z",
                    fill: "#2AA58F"
                })
            ]
        }),
        title: "Trusted Reviews",
        description: "Read reviews from real users who have booked and experienced the spaces."
    }
];


/***/ }),

/***/ 14685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Calendar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62469);
/* harmony import */ var react_day_picker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5036);
/* harmony import */ var _src_lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15939);
/* harmony import */ var _src_components_ui_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67896);






function Calendar(param) {
    let { className , classNames , showOutsideDays =true , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_day_picker__WEBPACK_IMPORTED_MODULE_2__/* .DayPicker */ ._W, {
        showOutsideDays: showOutsideDays,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("p-3 w-full", className),
        classNames: {
            months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0 w-full",
            month: "space-y-4 w-full",
            caption: "flex justify-center pt-1 relative items-center",
            caption_label: "text-sm font-medium",
            nav: "space-x-1 flex items-center",
            nav_button: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)((0,_src_components_ui_button__WEBPACK_IMPORTED_MODULE_4__/* .buttonVariants */ .d)({
                variant: "outline"
            }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-y-1",
            head_row: "flex w-full",
            head_cell: "text-gray-500 rounded-md flex-1 font-normal text-[0.8rem] text-center dark:text-gray-400",
            row: "flex w-full mt-2",
            cell: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("relative p-0 text-center text-sm flex-1 focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-gray-100 [&:has([aria-selected].day-outside)]:bg-gray-100/50 [&:has([aria-selected].day-range-end)]:rounded-r-md dark:[&:has([aria-selected])]:bg-gray-800 dark:[&:has([aria-selected].day-outside)]:bg-gray-800/50", props.mode === "range" ? "[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md" : "[&:has([aria-selected])]:rounded-md"),
            day: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)((0,_src_components_ui_button__WEBPACK_IMPORTED_MODULE_4__/* .buttonVariants */ .d)({
                variant: "ghost"
            }), "h-8 w-full p-0 font-normal aria-selected:opacity-100"),
            day_range_start: "day-range-start",
            day_range_end: "day-range-end",
            day_selected: "bg-gray-900 text-gray-50 hover:bg-gray-900 hover:text-gray-50 focus:bg-gray-900 focus:text-gray-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50 dark:hover:text-gray-900 dark:focus:bg-gray-50 dark:focus:text-gray-900",
            day_today: "bg-gray-100 text-gray-900 dark:bg-gray-800 dark:text-gray-50",
            day_outside: "day-outside text-gray-500 opacity-50 aria-selected:bg-gray-100/50 aria-selected:text-gray-500 aria-selected:opacity-30 dark:text-gray-400 dark:aria-selected:bg-gray-800/50 dark:aria-selected:text-gray-400",
            day_disabled: "text-gray-500 opacity-50 dark:text-gray-400",
            day_range_middle: "aria-selected:bg-gray-100 aria-selected:text-gray-900 dark:aria-selected:bg-gray-800 dark:aria-selected:text-gray-50",
            day_hidden: "invisible",
            ...classNames
        },
        components: {
            IconLeft: (param)=>/*#__PURE__*/ {
                let { ...props } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_5__/* .ChevronLeftIcon */ .wyc, {
                    className: "h-4 w-4"
                });
            },
            IconRight: (param)=>/*#__PURE__*/ {
                let { ...props } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_5__/* .ChevronRightIcon */ .XCv, {
                    className: "h-4 w-4"
                });
            }
        },
        ...props
    });
}
Calendar.displayName = "Calendar";



/***/ }),

/***/ 93409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J2": function() { return /* binding */ Popover; },
/* harmony export */   "xo": function() { return /* binding */ PopoverTrigger; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* unused harmony export PopoverAnchor */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63229);
/* harmony import */ var _src_lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15939);




const Popover = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC;
const PopoverTrigger = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz;
const PopoverAnchor = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_3__/* .Anchor */ .ee;
const PopoverContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , align ="center" , sideOffset =4 , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_3__/* .Portal */ .h_, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("z-50 w-72 rounded-md border border-gray-200 bg-white p-4 text-gray-950 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-gray-800 dark:bg-gray-950 dark:text-gray-50", className),
            ...props
        })
    });
});
PopoverContent.displayName = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_3__/* .Content.displayName */ .VY.displayName;



/***/ }),

/***/ 53666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ SelectContent; },
/* harmony export */   "DI": function() { return /* binding */ SelectGroup; },
/* harmony export */   "Ph": function() { return /* binding */ Select; },
/* harmony export */   "Ql": function() { return /* binding */ SelectItem; },
/* harmony export */   "i4": function() { return /* binding */ SelectTrigger; },
/* harmony export */   "ki": function() { return /* binding */ SelectValue; },
/* harmony export */   "n5": function() { return /* binding */ SelectLabel; }
/* harmony export */ });
/* unused harmony exports SelectSeparator, SelectScrollUpButton, SelectScrollDownButton */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62469);
/* harmony import */ var _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71890);
/* harmony import */ var _src_lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15939);





const Select = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC;
const SelectGroup = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Group */ .ZA;
const SelectValue = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Value */ .B4;
const SelectTrigger = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-gray-200 bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-white placeholder:text-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-950 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 dark:border-gray-800 dark:ring-offset-gray-950 dark:placeholder:text-gray-400 dark:focus:ring-gray-300", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                asChild: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_4__/* .CaretSortIcon */ .jnn, {
                    className: "h-4 w-4 opacity-50"
                })
            })
        ]
    });
});
SelectTrigger.displayName = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Trigger.displayName */ .xz.displayName;
const SelectScrollUpButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .ScrollUpButton */ .u_, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_4__/* .ChevronUpIcon */ .g8U, {})
    });
});
SelectScrollUpButton.displayName = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .ScrollUpButton.displayName */ .u_.displayName;
const SelectScrollDownButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .ScrollDownButton */ .$G, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_4__/* .ChevronDownIcon */ .v4q, {})
    });
});
SelectScrollDownButton.displayName = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .ScrollDownButton.displayName */ .$G.displayName;
const SelectContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , position ="popper" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Portal */ .h_, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY, {
            ref: ref,
            className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border border-gray-200 bg-white text-gray-950 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-gray-800 dark:bg-gray-950 dark:text-gray-50", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SelectScrollUpButton, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Viewport */ .l_, {
                    className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
                    children: children
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SelectScrollDownButton, {})
            ]
        })
    });
});
SelectContent.displayName = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Content.displayName */ .VY.displayName;
const SelectLabel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Label */ .__, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("px-2 py-1.5 text-sm font-semibold", className),
        ...props
    });
});
SelectLabel.displayName = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Label.displayName */ .__.displayName;
const SelectItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Item */ .ck, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-gray-100 focus:text-gray-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-gray-800 dark:focus:text-gray-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .ItemIndicator */ .wU, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_4__/* .CheckIcon */ .nQG, {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .ItemText */ .eT, {
                children: children
            })
        ]
    });
});
SelectItem.displayName = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Item.displayName */ .ck.displayName;
const SelectSeparator = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Separator */ .Z0, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("-mx-1 my-1 h-px bg-gray-100 dark:bg-gray-800", className),
        ...props
    });
});
SelectSeparator.displayName = _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_3__/* .Separator.displayName */ .Z0.displayName;



/***/ }),

/***/ 30533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useToastListener; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28442);
/* harmony import */ var _useListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96966);
/* harmony import */ var _components_ui_use_toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76718);
"use client";




function useToastListener() {
    const { toast  } = (0,_components_ui_use_toast__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .pm)();
    // Listen for success events
    (0,_useListener__WEBPACK_IMPORTED_MODULE_2__/* .useListener */ .o$)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .ALERT_EVENTS.SUCCESS */ .m0.SUCCESS, (message)=>{
        toast({
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-white leading-relaxed",
                children: message
            }),
            variant: "default",
            className: "\n          fixed top-0 right-0 w-screen mx-0 z-[100]\n          bg-green-600\n         \n          text-white shadow-2xl rounded-lg p-8 backdrop-blur-sm\n          animate-in slide-in-from-top-4 duration-700 ease-out\n          hover:shadow-3xl transition-all\n        ",
            duration: 4000
        });
    }, [
        toast
    ]);
    // Listen for error events
    (0,_useListener__WEBPACK_IMPORTED_MODULE_2__/* .useListener */ .o$)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .ALERT_EVENTS.ERROR */ .m0.ERROR, (message)=>{
        toast({
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-white text-center flex center justify-center leading-relaxed",
                children: message
            }),
            variant: "destructive",
            className: "\n          fixed top-0 right-0 w-screen mx-0 center  z-[100]\n          bg-red-600\n       \n          text-white shadow-2xl rounded-lg p-8 backdrop-blur-sm\n          animate-in slide-in-from-top-4 duration-700 ease-out\n          hover:shadow-3xl transition-all\n        ",
            duration: 5000
        });
    }, [
        toast
    ]);
}


/***/ }),

/***/ 60233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MJ": function() { return /* binding */ updateLandLordRequest; },
/* harmony export */   "PH": function() { return /* binding */ updateBookerRequest; },
/* harmony export */   "e6": function() { return /* binding */ getLandLordRequest; },
/* harmony export */   "nY": function() { return /* binding */ sendHomeEmail; },
/* harmony export */   "x6": function() { return /* binding */ getBookerRequest; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87066);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(237);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13568);
/* harmony import */ var _src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96966);
/* harmony import */ var _src_lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28442);





const getLandLordRequest = ()=>async (dispatch)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* .baseUrl.users */ .F.users, "/landlord"));
            dispatch((0,___WEBPACK_IMPORTED_MODULE_1__/* .setLandlordProfile */ .n5)(response.data));
        } catch (error) {
            console.log(error);
        }
    };
const getBookerRequest = ()=>async (dispatch)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* .baseUrl.users */ .F.users, "/booker"));
            dispatch((0,___WEBPACK_IMPORTED_MODULE_1__/* .setBookerProfile */ .J8)(response.data));
        } catch (error) {
            console.log(error);
        }
    };
// UpdateLandlord thunk for PATCH request with error handling and alert emission
const updateLandLordRequest = (landlordId, body)=>async (dispatch)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].patch */ .Z.patch("".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* .baseUrl.users */ .F.users, "/landlord/").concat(landlordId), body);
            (0,_src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__/* .emit */ .j8)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .ALERT_EVENTS.SUCCESS */ .m0.SUCCESS, "User Updated Sucessfully");
            dispatch((0,___WEBPACK_IMPORTED_MODULE_1__/* .setLandlordProfile */ .n5)(response.data));
        } catch (error) {
            let errorMsg = "An error occurred";
            if (error.response && error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
            } else if (error.message) {
                errorMsg = error.message;
            }
            (0,_src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__/* .emit */ .j8)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .ALERT_EVENTS.ERROR */ .m0.ERROR, errorMsg);
        }
    };
const updateBookerRequest = (landlordId, body)=>async (dispatch)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].patch */ .Z.patch("".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* .baseUrl.users */ .F.users, "/booker/").concat(landlordId), body);
            (0,_src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__/* .emit */ .j8)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .ALERT_EVENTS.SUCCESS */ .m0.SUCCESS, "User Updated Sucessfully");
            dispatch((0,___WEBPACK_IMPORTED_MODULE_1__/* .setBookerProfile */ .J8)(response.data));
        } catch (error) {
            let errorMsg = "An error occurred";
            if (error.response && error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
            } else if (error.message) {
                errorMsg = error.message;
            }
            (0,_src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__/* .emit */ .j8)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .ALERT_EVENTS.ERROR */ .m0.ERROR, errorMsg);
        }
    };
const sendHomeEmail = (email, message)=>async (dispatch)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].post */ .Z.post("".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* .baseUrl.users */ .F.users, "/send-email"), {
                email,
                message
            });
            (0,_src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__/* .emit */ .j8)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .ALERT_EVENTS.SUCCESS */ .m0.SUCCESS, "Email Sent Successfully ");
            dispatch((0,___WEBPACK_IMPORTED_MODULE_1__/* .setBookerProfile */ .J8)(response.data));
        } catch (error) {
            let errorMsg = "An error occurred";
            if (error.response && error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
            } else if (error.message) {
                errorMsg = error.message;
            }
            (0,_src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__/* .emit */ .j8)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .ALERT_EVENTS.ERROR */ .m0.ERROR, errorMsg);
        }
    };


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2671,1664,8675,8318,7536,8074,9341,8637,1890,5036,3743,3271,9350,8930,3338,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);